module.exports = __webpack_public_path__ + "static/media/8.b7763300.jpeg";